import React from "react";
import {Field} from "formik";
import {TextField, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import TypologieLavageSelector from "../../layout/forms/TypologieLavageSelector.js";

/**
 * Form mode opératoire (patron maison) : libellé + typologie de lavage (optionnel).
 * La gestion des fichiers PDF se fait à part (ModeOperatoireFichiersField), en édition.
 */
export default function ModeOperatoireForm({values, handleChange, handleBlur, setFieldValue, typologies = []}) {
    return (
        <Grid container spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Informations</Typography>
            </Grid>

            {/* LIBELLÉ */}
            <Grid item container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Libellé <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field type="text" value={values.libelle}>
                        {({form}) => (
                            <TextField
                                error={Boolean(form.errors.libelle && form.touched.libelle)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.libelle}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="libelle"
                                label="Libellé"
                                helperText={form.errors.libelle && form.touched.libelle && String(form.errors.libelle)}
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* TYPOLOGIE (optionnel) */}
            <Grid item container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Typologie de lavage
                </Grid>
                <Grid size={9}>
                    <Field name="typologieLavage">
                        {({form}) => (
                            <TypologieLavageSelector
                                typologies={[...typologies].sort((a, b) => (a.libelle || "").localeCompare(b.libelle || ""))}
                                value={values.typologieLavage}
                                onChange={(newValue) =>
                                    form.setFieldValue("typologieLavage", values.typologieLavage === newValue ? null : newValue)
                                }
                            />
                        )}
                    </Field>
                    <Typography variant="caption" color="textSecondary">
                        Optionnel — cliquez à nouveau pour désélectionner.
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
}
